// extracted by mini-css-extract-plugin
export var resultDetails = "adress-search-results-module--result-details--92982";
export var resultItem = "adress-search-results-module--result-item--bc345";
export var resultItemTaxo = "adress-search-results-module--result-item-taxo--77dbb";
export var resultItemTaxoContainer = "adress-search-results-module--result-item-taxo-container--ae118";
export var resultMore = "adress-search-results-module--result-more--26a9d";
export var resultTitle = "adress-search-results-module--result-title--f1aee";
export var resultTitleNotClickable = "adress-search-results-module--result-title-not-clickable--befa8";
export var resultTop = "adress-search-results-module--result-top--a8b56";
export var results = "adress-search-results-module--results--81987";
export var resultsContainer = "adress-search-results-module--results-container--3d372";